module.exports = __webpack_public_path__ + "img/wx.6ef9570a.jpg";